import { AuthPage } from 'components';
import { ProtectedRoute } from 'router';
import { appService } from 'services';

export const authRoutes = {
  forgotPassword: {
    path: '/mot-de-passe-oublie',
    component: () => (
      <ProtectedRoute>
        <AuthPage type="forgotPassword" />
      </ProtectedRoute>
    )
  },
  login: {
    path: '/connexion',
    component: () => (
      <ProtectedRoute>
        <AuthPage type="login" />
      </ProtectedRoute>
    )
  },
  registration: {
    path: '/inscription',
    component: () => (
      <ProtectedRoute>
        <AuthPage type={appService.isTouloisirs() ? 'registration' : 'arrivajRegistration'} />
      </ProtectedRoute>
    )
  },
  updatePassword: {
    path: '/modifier-mot-de-passe',
    component: () => (
      <ProtectedRoute>
        <AuthPage type="updatePassword" />
      </ProtectedRoute>
    )
  }
};
